import { Flex, IconButton } from '@chakra-ui/react';
import { NODE_HEIGHT_PX } from '@features/create/constants';
import { Handle, NodeProps, Position } from '@xyflow/react';
import { toPxString } from 'helpers/styles';
import { memo } from 'react';
import { PlusIcon } from 'vectors';

interface AddButtonNodeProps extends NodeProps {
  data: {
    addBlock: () => void;
  };
}
const AddButtonNode: React.FC<AddButtonNodeProps> = ({ data }) => {
  const { addBlock } = data;
  return (
    <Flex align="center" h={toPxString(NODE_HEIGHT_PX)}>
      <IconButton
        size="md"
        variant="surfaceOutline"
        borderRadius="full"
        color="text.secondary"
        _hover={{ color: 'text.primary' }}
        onClick={addBlock}
      >
        <PlusIcon />
      </IconButton>
      <Handle type="target" position={Position.Left} style={{ visibility: 'hidden' }} />
    </Flex>
  );
};

export default memo(AddButtonNode);
